module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/4_icon-c330c504b829c5da680ac6c4ed6a35a1.png";